import { TabView } from '@/features/app-tabs/tab-view';

/** Home landing tab — reference consumer of GET /user/home. */
export function HomeTabPage() {
  return <TabView tab="home" title="Home" />;
}
